import React from "react";

const NoNodesMessage = ({ message }) => {
  return (
    <tr>
      <td
        colSpan="5"
        className="text-center py-[30px] text-sm leading-6 text-lightBlack dark:text-semiWhite"
      >
        {`There is no information about ${message}`}
      </td>
    </tr>
  );
};

export default NoNodesMessage;
